import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import OperatorDashboard from "./screens/dashboard";
import OperatorHome from "./screens/home";
import OperatorLogin from "./screens/login";
import OperatorCreateNewEvent from "./screens/create-new-event";
import OperatorAllOpenEvents from "./screens/all-open-events";
import OperatorAllClosedEventList from "./screens/all-closed-events";
import OperatorCustomerHistory from "./screens/customer-history";
import OperatorAddCustomer from "./screens/add-customer";
import OperatorRewardsandReferrals from "./screens/rewards-referrals";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setUserLoginStatus } from "./store/userStatus";
import OperatorRegister from "./screens/register";
import OTPScreen from "./screens/otp-screen";
import SubscriptionRenewalPage from "./screens/subcription-expired";
import OperatorWallet from "./screens/wallet";
import UploadOldRecord from "./screens/old-entries-upload";
import OperatorPolicy from "./screens/policy";
import OperatorSettings from "./screens/settings";
import OperatorOperatorsList from "./screens/operators-list";
import RegistrationPaymentScreen from "./screens/registration-payment";
import OperatorEventList from "./screens/event-list";
import OperatorAutomationReport from "./screens/automation-report";
import OperatorLiveTracker from "./screens/live-tracker";
import { getStoredRegistrationPaymentStatus } from "./helpers/operatorSession";
import OperatorVillageManager from "./screens/village-manager";
import DuplicateEntries from "./screens/duplicate-entries";

// Private Route Wrapper
const PrivateRoute = () => {
  const { userLoggedIn } = useSelector((state) => state.userStatus);
  const token = localStorage.getItem("dwt-tok");
  const location = useLocation();
  const paymentStatus = getStoredRegistrationPaymentStatus();

  if (!userLoggedIn || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (
    paymentStatus &&
    !paymentStatus.paid &&
    location.pathname !== "/registration-payment"
  ) {
    return <Navigate to="/registration-payment" replace />;
  }
  return <Outlet />;
};

// Public Route Wrapper
const PublicRoute = () => {
  const { userLoggedIn } = useSelector((state) => state.userStatus);
  const token = localStorage.getItem("dwt-tok");
  const paymentStatus = getStoredRegistrationPaymentStatus();

  if (userLoggedIn && token) {
    return (
      <Navigate
        to={paymentStatus && !paymentStatus.paid ? "/registration-payment" : "/dashboard/home"}
        replace
      />
    );
  }
  return <Outlet />;
};

const AppNavigation = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dwt-tok");
    if (token) {
      dispatch(setUserLoginStatus(true));
    } else {
      dispatch(setUserLoginStatus(false));
    }
    setLoading(false); // Loading complete
  }, [dispatch]);

  if (loading) {
    return <div>Loading...</div>; // Placeholder for loading state
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/login" Component={OperatorLogin} />
          <Route
            path="/register/:refferal_code_org?"
            Component={OperatorRegister}
          />
          <Route path="/verify-mobile" Component={OTPScreen} />
          <Route path="/policies" Component={OperatorPolicy} />
        </Route>

        {/* Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route
            path="/registration-payment"
            Component={RegistrationPaymentScreen}
          />
          <Route path="/dashboard" Component={OperatorDashboard}>
            <Route path="home" Component={OperatorHome} />
            <Route path="live-tracker" Component={OperatorLiveTracker} />
            <Route path="create-new-event" Component={OperatorCreateNewEvent} />
            <Route path="old-record-upload" Component={UploadOldRecord} />
            <Route path="old-entries-upload" Component={UploadOldRecord} />
            <Route path="event-list" Component={OperatorEventList} />
            <Route path="automation-report" Component={OperatorAutomationReport} />
            <Route path="upcoming-events" Component={OperatorAllOpenEvents} />
            <Route path="events-history" Component={OperatorAllClosedEventList} />
            <Route path="villages" Component={OperatorVillageManager} />
            <Route path="duplicate-entries" Component={DuplicateEntries} />
            <Route
              path="customers-history"
              Component={OperatorCustomerHistory}
            />
            <Route path="add-customer" Component={OperatorAddCustomer} />
            <Route path="operators-list" Component={OperatorOperatorsList} />
            <Route
              path="rewards-referrals"
              Component={OperatorRewardsandReferrals}
            />
            <Route path="wallet" Component={OperatorWallet} />
            <Route path="settings" Component={OperatorSettings} />
            <Route
              path="subcription-expired"
              Component={SubscriptionRenewalPage}
            />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppNavigation;
